import React, { useState, forwardRef, useImperativeHandle } from "react";

import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';

export const ToastDesign = ({ open, handleClose, children, severity }) => (
    <Snackbar anchorOrigin={{ vertical: 'top', horizontal:'right' }} open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} variant="filled" severity={severity}>
            <ul dangerouslySetInnerHTML={{__html:children}}></ul>
        </Alert>
    </Snackbar>
)

export const Toast = forwardRef((props, ref) => {
    const [open, setOpen]   		= useState(false);
	const [message, setMessage]		= useState("");
	const [type, setType] 			= useState("");

    useImperativeHandle(ref, () => ({
        show (type, message) {
            setOpen(true);
            setMessage(message);
            setType(type);
        }
    }));

    const handleClose = () => {
        setOpen(false);
        setMessage("");
        setType("");
    }

    return (
        <ToastDesign
            open={open}
            handleClose={handleClose}
            severity={type}
        >
            {message}
        </ToastDesign>
    )
})

export default Toast;